import myAPI from './resources'
import config from '../config'

export default {
  getAll: function () {
    return myAPI.get(config.api_root + config.api_root_path_admin + '/notifications')
      .then(function (response) {
        return response
      })
  },
  save: function (notification) {
    return myAPI.post(config.api_root + config.api_root_path_admin + '/notifications', notification)
      .then(function (response) {
        return response
      })
  }
}


// WEBPACK FOOTER //
// ./src/api/notifications.js